export default {"src":"/_next/static/media/share-icon-black.72ce9e63.svg","height":16,"width":16};